var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutreachIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#F6F6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15301_79158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2919 10.583V7.70801H12.4169",
    stroke: "#403C6F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4169 10.583L15.2919 7.70801",
    stroke: "#403C6F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2919 14.8572V16.2947C15.2924 16.4282 15.2651 16.5603 15.2116 16.6825C15.1582 16.8048 15.0797 16.9146 14.9814 17.0048C14.8831 17.095 14.767 17.1637 14.6406 17.2064C14.5141 17.2492 14.3802 17.2651 14.2473 17.2531C12.7728 17.0928 11.3565 16.589 10.1121 15.782C8.95433 15.0463 7.97276 14.0648 7.23708 12.907C6.42727 11.657 5.92332 10.2337 5.76604 8.75264C5.75406 8.62013 5.76981 8.48659 5.81228 8.3605C5.85474 8.23441 5.923 8.11855 6.01269 8.02029C6.10239 7.92203 6.21157 7.84352 6.33327 7.78976C6.45497 7.73601 6.58653 7.70818 6.71958 7.70805H8.15708C8.38962 7.70577 8.61506 7.78811 8.79138 7.93975C8.9677 8.09138 9.08286 8.30196 9.11541 8.53222C9.17608 8.99225 9.2886 9.44394 9.45083 9.87868C9.5153 10.0502 9.52925 10.2366 9.49103 10.4158C9.45282 10.595 9.36403 10.7594 9.2352 10.8897L8.62666 11.4983C9.30878 12.6979 10.302 13.6911 11.5017 14.3733L12.1102 13.7647C12.2405 13.6359 12.405 13.5471 12.5842 13.5089C12.7633 13.4707 12.9497 13.4846 13.1212 13.5491C13.556 13.7113 14.0077 13.8238 14.4677 13.8845C14.7005 13.9174 14.913 14.0346 15.065 14.2139C15.217 14.3933 15.2977 14.6222 15.2919 14.8572Z",
    stroke: "#403C6F",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15301_79158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.5,
    height: 11.5,
    fill: "white",
    transform: "translate(4.75 6.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutreachIcon);
export default __webpack_public_path__ + "static/media/OutreachIcon.93fe0e3b25016c030ef4fa4963d6038d.svg";
export { ForwardRef as ReactComponent };